import { useEffect, useRef } from 'react';
import { track, waitForAnalytics } from '../AnalyticsUtils';
import { type TPage, TRACK_ACTION_TYPES } from '../utils/constants';

export const usePageViewed = (page: TPage) => {
	const hasTracked = useRef(false);

	useEffect(() => {
		if (hasTracked.current) {
			return;
		}
		hasTracked.current = true;

		waitForAnalytics(() => {
			track(`${page} Page Viewed`, {
				'Action Type': TRACK_ACTION_TYPES.PAGE_VIEWED,
				'Screen Name': `${page} Page`,
			});
		});
	}, [page]);
};
